export default `
	headline
	faq {
		... on FaqFaq {
			heading
			body {
				content
			}
		}
	}
`;
